/** True when the session user must not browse the dashboard. */
export function isAccountRestricted(user) {
  const status = String(user?.status ?? "active").toLowerCase();
  return status === "inactive" || status === "suspended";
}
